const colors = {}
colors.theme = {
  primary: '#132968',
  primaryLight1: '#425486',
  primaryLight2: '#3366A2',
  primaryLight3: '#5E90CC',
  primaryLight4: '#717FA4',
  primaryLight5: '#A1A9C3',
  primaryLight6: '#CDE2F5',
  primaryLight7: '#F5F9FD',
  primaryLight8: '#F1F2F6',
  secondary: '#24C89A',
  accent: '#24C89A',
  accentLight1: '#e6fef7',
  error: '#FA6B6B',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FA6B6B'
}
colors.rated1 = '#FF6F31'
colors.rated2 = '#FF9F02'
colors.rated3 = '#FFCF02'
colors.rated4 = '#9ACE6A'
colors.rated5 = '#57BB8A'

export default {
  campaign: {
    COLOR: '#24C89A'
  },
  colors: colors,
  defaultDateFormat: 'DD MMM, YYYY',
  roles: {
    OWNER: {
      id: 'OWNER',
      label: 'Owner',
      priority: 100
    },
    ADMIN: {
      id: 'ADMIN',
      label: 'Admin',
      priority: 60
    },
    GUEST: {
      id: 'GUEST',
      label: 'Guest',
      priority: 10
    }
  },
  questionLogicItems: [
    {
      id: 'ALL',
      label: 'Ask everyone'
    },
    {
      id: 'UNHAPPY',
      label: 'Ask only unhappy customers'
    },
    {
      id: 'NONE',
      label: 'Don\'t ask'
    },
  ]
}
